const emotesUrls = [];
emotesUrls.push('static-cdn.jtvnw.net');
emotesUrls.push('api.twitch.tv');
emotesUrls.push('api.frankerfacez.com');
emotesUrls.push('api.betterttv.net');
emotesUrls.push('api.7tv.app');
emotesUrls.push('cdn.7tv.app');

export const EMOTE_DOMAINS = emotesUrls;
